export default "__VITE_PUBLIC_ASSET__b468d9af__"